import { AppContent } from 'content/AppContent';

const mobileNumberMissing: AppContent['mobileNumberMissing'] = {
  mobileNumberMissingContent: [
    {
      serviceName: 'Online for Business',
      header: 'We don’t have a mobile number for you',
      infoNotification:
        'To register online, we’ll need a mobile number for you',
      content1:
        'That’s so we can text you a passcode to confirm it’s really you.',
      content2:
        'We also need your mobile number in case we need to get in touch. Or check it’s you when you’re making online purchases and payments.',
      content3: 'What to do next:',
      fillOutFormText: 'Fill out this form',
      fillOutFormLink:
        'https://apply.lloydsbank.co.uk/sales-content/cwa/l/gforms/F213/?WT.ac=lloyds-help_support-amendphone-chldpage-accmgmt-FOM-amend_phone_number&LBGAc=QU1DVlNfMjMwRDY0M0U1QTI1NTA5ODBBNDk1REI2JTQwQWRvYmVPcmc=.MQ==.T1BUT1VUTVVMVElNRVNTQUdF.MQ==.TEJHYzM=.bnM3YXVuaTAyMDBYNExGbGxveWRzYmFua2NvbQ==.T1BUT1VUTVVMVEk=.MDowfGMxOjF8YzM6MHxjNToxfGM0OjF8YzI6MA==.T1BUT1VUTVVMVEk=.MDowfGMxOjF8YzM6MHxjNToxfGM0OjF8YzI6MA==.QU1DVl8yMzBENjQzRTVBMjU1MDk4MEE0OTVEQjYlNDBBZG9iZU9yZw==.LTIxMjExNzkwMzN8TUNJRFRTfDE5ODI0fE1DTUlEfDg5ODUwMTc4ODg3MzcwMTQ0NDIzMzE5NDcxNzUwMTYzNDgwNDk0fE1DQUFNTEgtMTcxMzM2NjUwOHw2fE1DQUFNQi0xNzEzMzY2NTA4fDZHMXluWWNMUHVpUXhZWnJzel9wa3FmTEc5eU1YQnBiMnpYNWR2SmRZUUp6UFhJbWRqMHl8TUNPUFRPVVQtMTcxMjc2ODkwOXN8Tk9ORXxNQ0FJRHxOT05FfHZWZXJzaW9ufDUuMy4w.dHM=.bHV0eTR2cmk=#/?_k=53d7ik',
      listItem1: 'to tell us your mobile number.',
      listItem2: 'Print and sign it.',
      listItem3: 'Post it back to us.',
      backToWebsiteButton: 'Back to lloydsbank.com',
      backToWebsiteLink:
        'https://www.lloydsbank.com/business/banking-online/online-for-business/register-for-online-for-business.html',
    },
  ],
};

export default mobileNumberMissing;
